export default {
    'Version': '流程实例版本号',
    'FinishTime': '完成时间：{time}',
    'CancelTime': '作废时间：{time}',
    'CurNode': '当前节点',
    'CurHandler': '当前处理人',
    'UsedTime': '已用时{time}',
    'WorkflowTrack': '流程跟踪',
    'Edit': '编辑',
    'AdjustNode': '调整节点',
    'Nullify': '作废',
    'Delete': '删除',
    'Logs': '操作日志',
    'Finish': '结束',
    'EditOwner': '修改拥有者',
    'NullifyTips': '作废后该流程将停止流转，确定要作废？',
    'DeleteTips1': '流程删除后该流程所有数据将删除，',
    'DeleteTips2': '且删除后不可恢复，',
    'DeleteTips3': '确定要删除？',
    'FinishWorkflow': '提前结束流程',
    'FinishWorkflowTips': '确定立即结束流程？',
    'WorkflowChart': '流程图',
    'SmallScreen': '小屏',
    'ApprovalLog': '审批日志',
    'Back': '返回',
    'OperationLogs': '用户操作日志',
    'View': '查看',
    'DetailInfo': '详情信息',
    'Number': '序号',
    'OperationType': '操作类型',
    'OperationTime': '操作时间',
    'User': '用户',
    'Operations': '操作对象',
    'Platform': '平台',
    'Detail': '详细',
    'Assist': '的协办]',
    'AddWorkitem': '的加签]',
    'Circulate': '的传阅]',
    'Forward': '的转办]',
    'ActivityName': '节点名称',
    'ReceiveTime': '接收时间',
    'FinishTimes': '完成时间',
    'CostTime': '耗时',
    'Originator': '参与者',
    'ApprovalAction': '操作',
    'FinishNode': '已办节点',
    'ProcessNode': '进行中节点',
    'ExceptionNode': '异常节点',
    'UnstartNode': '未开始',
    'WorkflowName': '流程名称',
    'Status': '状态',
    'StartTime': '开始时间',
    'FinishedTime': '结束时间',
    'BaseInfo': '基本信息',
    'NoFinishOriginator': '未完成的参与者',
    'ViewDetails': '查看详情',
    'ChooseAdjustType': '选择调整类型',
    'AdjustOriginator': '调整当前处理人',
    'CancelAllTask': '取消当前节点所有任务',
    'ActivateNodes': '激活其它节点',
    'AdjustNodeTips': '小提示：流程会停滞，保持当前状态，管理员可以继续激活到其他节点',
    'notNodeTips': '当前无可用节点',
    'ChooseNode': '选择节点',
    'ChooseHandler': '选择处理人',
    'ClickChoose': '点击选择',
    'Null': '空',
    'Nothing': '无',
    'Cancel': '取消',
    'OK': '确定',
    'Predictor': '预估处理人',
    'NoDetail': '暂无内容',
    'trust': '【{name}委托】',
    'trust2': '委托',
    'WorkflowState': {
        'Draft': '草稿',
        'Processing': '进行中',
        'Completed': '已完成',
        'Canceled': '已作废',
        'Exception': '异常',
    },
    'WorkflowActionStatus': {
        'Submit': '提交',
        'Submits': '提交',
        'Cancel': '作废',
        'Agree': '同意',
        'DisAgree': '不同意',
        'AdjustParticipant': '加签',
        'Assist': '协办',
        'Forward': '转办',
        'Reject': '驳回',
        'FinishInstance': '结束流程',
        'UnRead': '待阅',
        'Read': '已阅',
        'Circularize': '传阅',
        'Empty': '',
        'Revoke': '撤回',
        'BeCanceled': '被取消',
        'AutoCanceled': '自动取消',
    },
    'WorkItemStatus': {
        'NotStarted': '未启动',
        'Processing': '进行中',
        'Completed': '已完成',
        'Canceled': '被取消',
        'Draft': '草稿',
        'BeCanceled': '被取消',
    },
    'SubWorkItemStatus': {
        'NotStarted': '未启动',
        'Processing': '进行中',
        'Completed': '已完成',
        'Canceled': '已作废',
        'Exception': '流程异常',
        'BeCanceled': '被取消',
    },
};
